import { Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import HomePage from './pages/HomePage';
import ItemDetailsPage from './pages/ItemDetailsPage';
import CategoryPage from './pages/CategoryPage';
import CategoriesPage from './pages/CategoriesPage';
import UserProfilePage from './pages/UserProfilePage';
import MyAdsPage from './pages/MyAdsPage';
import SavedItemsPage from './pages/SavedItemsPage';
import PostAdPage from './pages/PostAdPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import TrustScoreDemo from './pages/TrustScoreDemo';
import SmartListingDemo from './pages/SmartListingDemo';
import DiscoveryFeedDemo from './pages/DiscoveryFeedDemo';
import InfoPage from './pages/InfoPage';
import { ProtectedRoute } from './components/ProtectedRoute';
import ScrollToTop from './components/ScrollToTop';
import { preloadCategories } from './hooks/useCategories';

// Preload categories on app start for instant PostAdPage navigation
preloadCategories();

export default function App(): JSX.Element {
  // Also preload when app mounts (for hot reloads, etc.)
  useEffect(() => {
    preloadCategories();
  }, []);
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/verify-email/:token" element={<VerifyEmailPage />} />
        <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
        <Route path="/item/:id" element={<ItemDetailsPage />} />
        <Route path="/category/:categoryName" element={<CategoryPage />} />
        <Route path="/categories" element={<CategoriesPage />} />
        <Route path="/listings" element={<CategoriesPage />} />
        <Route path="/about" element={<InfoPage kind="about" />} />
        <Route path="/contact" element={<InfoPage kind="contact" />} />
        <Route path="/careers" element={<InfoPage kind="careers" />} />
        <Route path="/help-center" element={<InfoPage kind="help" />} />
        <Route path="/safety-tips" element={<InfoPage kind="safety" />} />
        <Route path="/report-ad" element={<InfoPage kind="report" />} />
        <Route path="/terms" element={<InfoPage kind="terms" />} />
        <Route path="/privacy" element={<InfoPage kind="privacy" />} />
        <Route path="/sitemap" element={<InfoPage kind="sitemap" />} />
        <Route path="/demo/trust-score" element={<TrustScoreDemo />} />
        <Route path="/demo/smart-listing" element={<SmartListingDemo />} />
        <Route path="/demo/discovery-feed" element={<DiscoveryFeedDemo />} />
        <Route 
          path="/profile" 
          element={
            <ProtectedRoute>
              <UserProfilePage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/profile/my-ads" 
          element={
            <ProtectedRoute>
              <MyAdsPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/profile/saved" 
          element={
            <ProtectedRoute>
              <SavedItemsPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/post-ad" 
          element={
            <ProtectedRoute>
              <PostAdPage />
            </ProtectedRoute>
          } 
        />
      </Routes>
    </>
  );
}
